import { useState, useRef, useEffect } from "react";
import { RefreshCw, Search, MoreHorizontal, Plus, Filter } from "lucide-react";

// Compact toolbar row rendered inside the board page. Consumers pass in
// their own children for the chips strip / filters popover contents.
export default function CompactBoardToolbar({
  countChips = [],
  searchValue,
  onSearchChange,
  onRefresh,
  onOpenFilters,
  filtersActive = false,
  overflowItems = [],
  extraRight,
  testIdPrefix = "board",
}) {
  const [overflowOpen, setOverflowOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const close = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOverflowOpen(false);
    };
    if (overflowOpen) document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [overflowOpen]);
  return (
    <div className="compact-board-toolbar" data-testid={`${testIdPrefix}-toolbar`}>
      {countChips.map((c) => (
        <button
          className={`toolbar-chip${c.active ? " is-active" : ""}`}
          data-testid={`${testIdPrefix}-chip-${c.key}`}
          key={c.key}
          onClick={c.onClick}
          type="button"
        >
          <strong>{c.value}</strong>
          <span>{c.label}</span>
        </button>
      ))}
      <input
        aria-label="Search projects"
        className="toolbar-search"
        data-testid={`${testIdPrefix}-search`}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search"
        value={searchValue}
      />
      {onOpenFilters && (
        <button
          aria-label="Filters"
          className="toolbar-icon-btn"
          data-testid={`${testIdPrefix}-filters-btn`}
          onClick={onOpenFilters}
          style={{ background: filtersActive ? "#0f172a" : "#fff", color: filtersActive ? "#fff" : undefined }}
          type="button"
        >
          <Filter size={14} />
        </button>
      )}
      <button
        aria-label="Refresh"
        className="toolbar-icon-btn"
        data-testid={`${testIdPrefix}-refresh-btn`}
        onClick={onRefresh}
        type="button"
      >
        <RefreshCw size={14} />
      </button>
      {extraRight}
      {overflowItems.length > 0 && (
        <div ref={menuRef} style={{ position: "relative" }}>
          <button
            aria-label="More"
            className="toolbar-icon-btn"
            data-testid={`${testIdPrefix}-overflow-btn`}
            onClick={() => setOverflowOpen((v) => !v)}
            type="button"
          >
            <MoreHorizontal size={14} />
          </button>
          {overflowOpen && (
            <div className="board-overflow-menu" data-testid={`${testIdPrefix}-overflow-menu`}>
              {overflowItems.map((item, idx) =>
                item.to ? (
                  <a
                    data-testid={item.testId}
                    href={item.to}
                    key={item.key || idx}
                    onClick={(e) => { setOverflowOpen(false); if (item.onNavigate) { e.preventDefault(); item.onNavigate(); } }}
                  >
                    {item.label}
                  </a>
                ) : (
                  <button
                    data-testid={item.testId}
                    key={item.key || idx}
                    onClick={() => { setOverflowOpen(false); item.onClick(); }}
                    type="button"
                  >
                    {item.label}
                  </button>
                ),
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

CompactBoardToolbar.PlusIcon = Plus;
CompactBoardToolbar.SearchIcon = Search;
